import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getPostById } from '../services/posts';
import { PostCard } from '../components/posts/PostCard';
import { useAuth } from '../hooks/useAuth';
import { Navigate } from 'react-router-dom';

export default function PostDetailPage() {
  const { postId } = useParams<{ postId: string }>();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const { data: post, isLoading, isError } = useQuery({
    queryKey: ['posts', postId],
    queryFn: () => getPostById(postId!),
    enabled: !!postId && isAuthenticated,
  });

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isLoading) {
    return (
      <div className="max-w-2xl mx-auto">
        <div className="animate-pulse space-y-4">
          <div className="h-48 bg-gray-200 rounded-xl" />
          <div className="h-4 bg-gray-200 rounded w-3/4" />
          <div className="h-4 bg-gray-200 rounded w-1/2" />
        </div>
      </div>
    );
  }

  if (isError || !post) {
    return (
      <div className="max-w-2xl mx-auto text-center py-12">
        <p className="text-gray-500">Opslaget kunne ikke hentes.</p>
        <button
          onClick={() => navigate('/')}
          className="mt-4 text-primary-600 hover:underline text-sm"
        >
          Gå til forsiden
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto">
      <button
        onClick={() => navigate(-1)}
        className="mb-3 flex items-center gap-1 text-sm text-gray-500 hover:text-gray-800 transition-colors"
      >
        ← Tilbage
      </button>
      <PostCard post={post} />
    </div>
  );
}
